import { TagIcon } from 'lucide-react';

import { cn } from '@/shared/lib/utils';

interface QuantityPromotionChipProps {
  /** Texto curto: "2º com 50%" (card) ou "2º item com 50%" (cabeçalho). */
  label: string;
  className?: string;
}

/**
 * Chip da promoção por quantidade (PRAT-184) na cor principal da loja. Marca,
 * no catálogo, os produtos e as categorias que participam — para ninguém pôr
 * um X-Salada de "Lanches e Combos" achando que entra na promoção de
 * "Hambúrguers".
 */
export function QuantityPromotionChip({ label, className }: QuantityPromotionChipProps) {
  return (
    <span
      data-testid="quantity-promotion-chip"
      className={cn(
        'inline-flex shrink-0 items-center rounded-full bg-primary px-2 py-0.5 text-[10px] font-bold leading-tight text-primary-foreground shadow-sm whitespace-nowrap',
        className
      )}
    >
      {label}
    </span>
  );
}

interface QuantityPromotionNoteProps {
  /** "Promoção: 2º item com 50% — vale para Hambúrguers" */
  note: string;
  className?: string;
}

/**
 * Linha da página/drawer do produto (PRAT-184) dizendo que ele participa da
 * promoção por quantidade e para quais categorias ela vale.
 */
export function QuantityPromotionNote({ note, className }: QuantityPromotionNoteProps) {
  return (
    <p
      data-testid="quantity-promotion-note"
      className={cn('flex items-start gap-1.5 text-xs font-semibold text-primary', className)}
    >
      <TagIcon aria-hidden className="mt-0.5 size-3.5 shrink-0" strokeWidth={2.5} />
      <span>{note}</span>
    </p>
  );
}
